/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadPalInfo } from './LeadPalInfo';
import {
    LeadPalInfoFromJSON,
    LeadPalInfoFromJSONTyped,
    LeadPalInfoToJSON,
} from './LeadPalInfo';

/**
 * 
 * @export
 * @interface FindOnePalInfo200Response
 */
export interface FindOnePalInfo200Response {
    /**
     * 
     * @type {LeadPalInfo}
     * @memberof FindOnePalInfo200Response
     */
    data?: LeadPalInfo;
}

/**
 * Check if a given object implements the FindOnePalInfo200Response interface.
 */
export function instanceOfFindOnePalInfo200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOnePalInfo200ResponseFromJSON(json: any): FindOnePalInfo200Response {
    return FindOnePalInfo200ResponseFromJSONTyped(json, false);
}

export function FindOnePalInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePalInfo200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadPalInfoFromJSON(json['data']),
    };
}

export function FindOnePalInfo200ResponseToJSON(value?: FindOnePalInfo200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadPalInfoToJSON(value.data),
    };
}

